import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import { Link } from "react-router-dom";
import {
  User,
  Calendar,
  Hash,
  LogOut,
  Key,
  ArrowLeft,
  Loader2,
} from "lucide-react";
import { styles } from "../utils/globalStyles"; // Import style global

export default function ProfilSiswa({ user, onLogout }) {
  const [siswaData, setSiswaData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchProfil() {
      if (!user) return;

      try {
        // Cari data detail di tabel 'siswa' berdasarkan nama
        // Asumsi: nama di tabel 'akun' sama dengan nama di tabel 'siswa'
        const { data, error } = await supabase
          .from("siswa")
          .select("*")
          .ilike("nama_lengkap", user.nama)
          .single();

        if (error) throw error;
        setSiswaData(data);
      } catch (err) {
        console.error("Gagal ambil profil:", err);
      } finally {
        setLoading(false);
      }
    }

    fetchProfil();
  }, [user]);

  // Format Tanggal Lahir (YYYY-MM-DD -> 1 Januari 2000)
  const formatTTL = (dateString) => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleDateString("id-ID", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  if (loading) {
    return (
      <div
        style={{
          ...styles.container,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Loader2 className="animate-spin" color="#2563EB" />
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {/* HEADER KHUSUS PROFIL */}
      <div
        style={{
          ...styles.headerHero,
          paddingBottom: "50px",
          borderRadius: "0 0 30px 30px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "15px",
          }}
        >
          <div
            style={{
              width: 80,
              height: 80,
              background: "white",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
            }}
          >
            <User size={40} color="#334155" />
          </div>
        </div>
        <h2 style={{ margin: 0, fontSize: "20px", fontWeight: "bold" }}>
          {user.nama}
        </h2>
        <p style={{ margin: "5px 0 0 0", fontSize: "13px", opacity: 0.8 }}>
          {siswaData?.kelas || "Siswa"}
        </p>
      </div>

      <div
        style={{
          padding: "0 25px",
          marginTop: "-30px",
          position: "relative",
          zIndex: 10,
        }}
      >
        {/* KARTU INFO UTAMA */}
        <div style={styles.floatingCard}>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            {/* USERNAME */}
            <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
              <div
                style={{
                  background: "#EFF6FF",
                  padding: 10,
                  borderRadius: 10,
                  color: "#2563EB",
                }}
              >
                <Hash size={20} />
              </div>
              <div>
                <div
                  style={{
                    fontSize: "11px",
                    color: "#64748B",
                    fontWeight: "600",
                    textTransform: "uppercase",
                  }}
                >
                  Username
                </div>
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: "#334155",
                  }}
                >
                  {user.username}
                </div>
              </div>
            </div>

            {/* TEMPAT TANGGAL LAHIR */}
            <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
              <div
                style={{
                  background: "#F0FDF4",
                  padding: 10,
                  borderRadius: 10,
                  color: "#16A34A",
                }}
              >
                <Calendar size={20} />
              </div>
              <div>
                <div
                  style={{
                    fontSize: "11px",
                    color: "#64748B",
                    fontWeight: "600",
                    textTransform: "uppercase",
                  }}
                >
                  Tanggal Lahir
                </div>
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: "#334155",
                  }}
                >
                  {siswaData?.tanggal_lahir
                    ? formatTTL(siswaData.tanggal_lahir)
                    : "-"}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* MENU AKSI */}
        <div
          style={{
            marginTop: "20px",
            display: "flex",
            flexDirection: "column",
            gap: "12px",
          }}
        >
          <Link to="/ganti-password" style={{ textDecoration: "none" }}>
            <button
              style={{
                ...styles.compactCard,
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                cursor: "pointer",
                border: "none",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "12px" }}
              >
                <Key size={18} color="#F59E0B" />
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#334155",
                  }}
                >
                  Ganti Password
                </span>
              </div>
              <ArrowLeft
                size={16}
                style={{ transform: "rotate(180deg)", color: "#CBD5E1" }}
              />
            </button>
          </Link>

          <button
            onClick={onLogout}
            style={{
              ...styles.compactCard,
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              border: "1px solid #FEE2E2",
              background: "#FEF2F2",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                color: "#EF4444",
              }}
            >
              <LogOut size={18} />
              <span style={{ fontSize: "14px", fontWeight: "700" }}>
                Keluar Aplikasi
              </span>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}
